import { useState } from "react";
import {
  Table,
  Space,
  Button,
  Modal,
  message,
} from "antd";
import TypeInvestigationService from "../../../services/TypeInvestigationService";
import TypeInvestigationModalForm from "./TypeInvestigationModalForm";

const getColumns = (
  setTypeInvestigationTarget,
  showModalForm,
  showModalDelete
) => {
  return [
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      width: "100px",
      render: (text, record) => <span>{record.name}</span>,
      fixed: "left",
    },
    {
      title: "Acciones",
      key: "action",
      width: "150px",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            onClick={() => {
              setTypeInvestigationTarget(record);
              showModalForm();
            }}
          >
            Editar
          </Button>
          <Button
            type="link"
            onClick={() => {
              setTypeInvestigationTarget(record);
              showModalDelete();
            }}
          >
            Eliminar
          </Button>
        </Space>
      ),
    },
  ];
};
export default function TypeInvestigation({
  list = [],
  getData,
  setTypeInvestigations,
}) {
  const [typeInvestigationTarget, setTypeInvestigationTarget] = useState(null);
  const [isModalFormVisible, setIsModalFormVisible] = useState(false);
  const [isModalDeleteVisible, setIsModalDeleteVisible] = useState(false);

  const showModalDelete = () => {
    setIsModalDeleteVisible(true);
  };
  const handleOkDelete = () => {
    TypeInvestigationService.deleteTypeInvestigation(typeInvestigationTarget)
      .then((res) => {
        if (res.data?.success) {
          message.success("Tipo de investigación eliminado.", 3);
          getData()
            .then((res) => {
              handleCancelDelete();
              setTypeInvestigations(res);
            })
            .catch((e) => {
              console.log("error", e.message);
              message.error(
                "No se pudo obtener la lista de Tipo de investigaciones.",
                5
              );
            });
        } else {
          message.error(
            "No se pudo eliminar el Tipo de investigación. " +
              res.data?.description,
            5
          );
        }
      })
      .catch((e) => {
        console.log("error.", e.message);
        message.error("Hubo un error. " + e.message, 5);
      });
  };

  const handleCancelDelete = () => {
    setTypeInvestigationTarget(null);
    setIsModalDeleteVisible(false);
  };

  const showModalForm = () => {
    setIsModalFormVisible(true);
  };
  const handleOkForm = () => {
    getData()
      .then((res) => {
        setTypeInvestigationTarget(null);
        setIsModalFormVisible(false);
        setTypeInvestigations(res);
      })
      .catch((e) => {
        console.log("error", e.message);
        message.error("No se pudo obtener la lista de carreras.", 5);
      });
  };

  const handleCancelForm = () => {
    setTypeInvestigationTarget(null);
    setIsModalFormVisible(false);
  };
  return (
    <>
      <Button
        type="primary"
        onClick={() => {
          showModalForm();
        }}
        style={{ marginBottom: "1em" }}
      >
        +Registrar nuevo Tipo de investigación
      </Button>
      <Table
        columns={getColumns(
          setTypeInvestigationTarget,
          showModalForm,
          showModalDelete
        )}
        dataSource={list}
        rowKey="id"
        scroll={{ x: "max-content" }}
      />
      {isModalFormVisible ? (
        <TypeInvestigationModalForm
          isModalVisible={isModalFormVisible}
          handleOk={handleOkForm}
          handleCancel={handleCancelForm}
          typeInvestigationTarget={typeInvestigationTarget}
        />
      ) : null}
      {isModalDeleteVisible ? (
        <Modal
          visible={isModalDeleteVisible}
          title="Eliminar Tipo de investigación"
          onOk={handleOkDelete}
          onCancel={handleCancelDelete}
          okText="Aceptar"
          cancelText="Cancelar"
        >
          <p>
            ¿Desea eliminar el Tipo de investigación{" "}
            <strong>{typeInvestigationTarget?.name}</strong>?
          </p>
        </Modal>
      ) : null}
    </>
  );
}
